import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useContext } from 'react';
import { ClosestStationContext } from 'contexts/ClosestStationContext';

const WindSpeedScalarTable = () => {
  const { closestStation } = useContext(ClosestStationContext);
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>Jan</TableCell>
          <TableCell>Feb</TableCell>
          <TableCell>Mar</TableCell>
          <TableCell>Apr</TableCell>
          <TableCell>May</TableCell>
          <TableCell>Jun</TableCell>
          <TableCell>Jul</TableCell>
          <TableCell>Aug</TableCell>
          <TableCell>Sep</TableCell>
          <TableCell>Oct</TableCell>
          <TableCell>Nov</TableCell>
          <TableCell>Dec</TableCell>
          <TableCell>Avg</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
          <TableCell>{closestStation?.jan}</TableCell>
          <TableCell>{closestStation?.feb}</TableCell>
          <TableCell>{closestStation?.mar}</TableCell>
          <TableCell>{closestStation?.apr}</TableCell>
          <TableCell>{closestStation?.may}</TableCell>
          <TableCell>{closestStation?.jun}</TableCell>
          <TableCell>{closestStation?.jul}</TableCell>
          <TableCell>{closestStation?.aug}</TableCell>
          <TableCell>{closestStation?.sep}</TableCell>
          <TableCell>{closestStation?.oct}</TableCell>
          <TableCell>{closestStation?.nov}</TableCell>
          <TableCell>{closestStation?.dec}</TableCell>
          <TableCell>{closestStation?.avgYear}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

export default WindSpeedScalarTable;
